export default __webpack_public_path__ + "static/media/spark.24a27563.svg";